import { browser } from "$app/environment"
import { z } from "zod/v4"

const DeviceSchema = z.object({
  app_version: z.string().default(""),
  is_test: z.boolean().default(false),
  is_guest: z.boolean().default(true),
  is_phone: z.boolean().default(browser && window.innerWidth <= 480),

  device_id: z.string().default(""),
  device_name: z.string().default(""),
  device_brand: z.string().default(""),
  device_product: z.string().default(""),
  device_os: z.number().default(0),
  device_os_code: z.string().default(""),

  region_id: z.string().default(""),
  region_offset: z.number().default(0),
})

export type Device = z.infer<typeof DeviceSchema>
export const DeviceEmpty = DeviceSchema.parse({})